module.exports = __webpack_public_path__ + "static/media/image3.6a0355c9.jpg";